const MEASUREMENT_ID = process.env.VUE_APP_GA_MEASUREMENT_ID

export function initAnalytics() {
    if (!MEASUREMENT_ID || typeof window === 'undefined') {
        return
    }

    window.dataLayer = window.dataLayer || []
    window.gtag = function() {
        window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    // page views are sent manually on every route change (see trackPageView)
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
    document.head.appendChild(script)
}

export function trackPageView(to) {
    if (!MEASUREMENT_ID || !window.gtag) {
        return
    }

    window.gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_location: window.location.href,
        page_title: document.title
    })
}
